import React, { PropTypes } from 'react';
import StyleButton from './StyleButton.js.jsx';

const BLOCK_TYPES = [
  {label: <i key={'link'} className="fa fa-link"/>, style: 'link'},
  {label: <i key={'unlink'} className="fa fa-link unlink"/>, style: 'unlink'},
];

const LinkControls = (props) => {
  const {editorState} = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className="RichEditor-controls">
      {BLOCK_TYPES.map((type, i) =>
        <StyleButton
          key={i}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
          promptForLink={props.promptForLink}
          removeLink={props.removeLink}
        />
      )}
    </div>
  );
};

export default LinkControls;



// WEBPACK FOOTER //
// global/components/forms/editorComponents/LinkControls.js.jsx